import type { ClubPlayer } from "@mixitone/models";
import ClubPlayerFormController from "components/Forms/ClubPlayerFormController";
import type { CustomComponentFieldProps } from "components/Forms/FormFieldsDefinition";
import { GroupSelect } from "components/GroupSelect";

const GroupSelectField: React.FC<CustomComponentFieldProps<ClubPlayer>> = ({ ...props }) => {
  const controller = ClubPlayerFormController.use();
  const { club } = controller.state;
  const { group } = controller;

  return (
    <GroupSelect
      {...props}
      name="group_id"
      clubGroups={club.groups}
      value={group}
      onSelectGroup={(group) => {
        controller.state.record.group = group;
      }}
    />
  );
};

export default GroupSelectField;
